/**
 * @file
 * @author dailin01
 */
import React, { useContext } from 'react';
import classNames from 'classnames';
import { ItemGroup } from './rc-menu';
import Item from './MenuItem';
import ItemCustom from './MenuItemCustom';
import SubMenu from './SubMenu';
import MenuHead from './MenuHead';
import HeaderMenu from './header';
import GlobalSiderBar from './globalSilderBar';
import BasicMenu from './baseMenu';
import MenuContext from './MenuContext';
import { ConfigContext } from '../config-provider';
;
const Menu = props => {
    const { 
    // Menu本身配置
    prefixCls: customizePrefixCls, mode = 'horizontal', iconList = [], inlineCollapsed, scope = 'local' } = props;
    const { getPrefixCls } = React.useContext(ConfigContext);
    const prefixCls = getPrefixCls('menu', customizePrefixCls);
    const menuContextValue = useContext(MenuContext);
    if (scope === 'global') {
        if (mode === 'horizontal') {
            return (<MenuContext.Provider value={Object.assign(Object.assign({}, menuContextValue), { menuMode: mode, inlineCollapsed,
                    prefixCls,
                    scope })}>
                    <HeaderMenu {...props}/>
                </MenuContext.Provider>);
        }
        if (mode === 'inline') {
            return (<MenuContext.Provider value={Object.assign(Object.assign({}, menuContextValue), { menuMode: mode, inlineCollapsed,
                    prefixCls, firstLevel: true, scope })}>
                    <GlobalSiderBar {...props}/>
                </MenuContext.Provider>);
        }
    }
    const containerClsName = classNames({
        [`${prefixCls}-icon-container`]: mode === 'horizontal' && iconList.length
    });
    return (<MenuContext.Provider value={Object.assign(Object.assign({}, menuContextValue), { firstLevel: true, menuMode: mode, inlineCollapsed,
            prefixCls,
            scope })}>
            {mode === 'horizontal' && iconList.length ? (<div className={containerClsName}>
                    <BasicMenu {...props}/>
                    <div className={`${prefixCls}-iconlist`}>
                        {iconList.map((item, idx) => <span key={idx} className="icon-item">{item}</span>)}
                    </div>
                </div>) : (<BasicMenu {...props}/>)}
        </MenuContext.Provider>);
};
Menu.Item = Item;
Menu.SubMenu = SubMenu;
Menu.MenuHead = MenuHead;
Menu.ItemGroup = ItemGroup;
Menu.ItemCustom = ItemCustom;
export default Menu;
